import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TonguePiercingImage from '../../Assets/Piercing Services/tongue piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TonguePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Tongue Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Tongue Piercing Dubai, UAE performed by trained professionals with careful placement, quality jewellery and proper hygiene standards."
            />  
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Tongue Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Tongue Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TonguePiercingImage} alt="Tongue Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Tongue Piercing</h3>

          <p>
            Express your unique personality with our professional tongue piercing services in the UAE, available at an affordable price of 200 AED. Tongue piercing is a bold and stylish choice for individuals who want to stand out and showcase their individuality with confidence. Known for its edgy appeal and modern trend, tongue piercing has become increasingly popular among those looking to make a statement while embracing a distinctive look. Our expert specialists ensure precise placement and a smooth procedure, helping you achieve a safe and stylish result that complements your personality.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and client comfort at every step. Our certified professionals use sterile, single-use, high-quality equipment to perform each tongue piercing with maximum care and precision. We strictly follow hygiene protocols to maintain a clean and sanitized environment, reducing the risk of infection and ensuring a safe experience. Our goal is to provide a quick, efficient, and pain-minimized procedure so you can enjoy your piercing with confidence and ease.
          </p>

          <p>
            Tongue piercing requires a high level of expertise, and our experienced specialists are trained in advanced techniques to ensure accurate positioning and minimal discomfort. The procedure is typically completed within minutes, making it convenient even for those with busy schedules. We also use premium, hypoallergenic starter jewelry that is safe for sensitive tissues, helping to reduce irritation and promote faster healing.
          </p>

          <p>
            This piercing option is ideal for individuals who want to express themselves in a bold yet stylish way. Tongue piercing can be both a fashion statement and a form of self-expression, allowing you to showcase your individuality while keeping your look versatile. Whether you prefer a subtle or more noticeable style, our team will guide you in choosing the right jewelry and placement that suits your preference and comfort.
          </p>

          <p>
            Our clean and welcoming environment ensures that you feel relaxed and well cared for throughout your visit. We understand that tongue piercing can feel intimidating for first-timers, which is why our friendly professionals are always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a comfortable and positive experience.
          </p>

          <p>
            Aftercare is especially important for tongue piercings, and we provide detailed instructions to help you maintain proper hygiene during the healing process. Our specialists will guide you on cleaning routines, dietary precautions, and tips to reduce swelling and avoid complications. Following proper aftercare ensures faster healing and helps maintain the health of your piercing.
          </p>

          <p>
            Our tongue piercing services in the UAE combine affordability with premium quality, offering excellent value without compromising on safety or professionalism. We maintain transparent pricing with no hidden costs, ensuring you receive top-quality service at a competitive rate. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule.
          </p>

          <p>
            Choose our trusted tongue piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, advanced techniques, and a commitment to customer satisfaction, we help you achieve a bold and confident look effortlessly. Book your tongue piercing appointment today and express your individuality with style and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Tongue Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TonguePiercing;